import React from 'react'
import styles from './ShopByLayout.module.scss'
import { To, useNavigate } from 'react-router-dom'

type Props = {
    children?: React.ReactNode
    label: string
    hideButtons?: boolean
    navigateUrl?: To
}

const ShopByLayout: React.FC<Props> = (props: Props) => {
    const navigate = useNavigate();

    const navigateFn = () => {
        navigate(props.navigateUrl!);
        window.scrollTo(0, 0); // Scroll to the top
    }

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <h1 className={styles.headerTitle}>{props.label}</h1>
                {
                    !props.hideButtons && <button className={`standardButton ${styles.headerButton}`} onClick={() => props.navigateUrl ? navigateFn()  : null}>See more</button>
                }
            </div>
            <div className={styles.layout}>
                {props.children}
            </div>
            <button className={`standardButton ${styles.footerButton}`}>See more</button>
        </div>
    )
}

export default ShopByLayout